<div class="ui-component advanced-search-bar">
    <mat-expansion-panel class="advanced-search-panel mat-elevation-z0" [expanded]="isExpand" hideToggle="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="search-title">
            <strong data-cy="search-header">{{ 'concepts.table_filter.header' | translate }}</strong>
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <form [formGroup]="filterForm">
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <carm-select-field
                        [group]="filterForm"
                        controlName="criteriaField"
                        inId="criteria_field"
                        inName="criteriaField"
                        inLabel="{{ 'concepts.table_filter.field' | translate }}"
                        [inOptions]="filterOptions"
                        [fitToSize]="true"
                        >
                    </carm-select-field>
                </div>
                <div *ngIf="!!selectOptions" class="col-md-6 col-sm-6">
                    <carm-select-field
                        [group]="filterForm"
                        controlName="criteriaValue"
                        inId="criteria_value"
                        inName="criteriaValue"
                        inLabel="{{ 'concepts.table_filter.field' | translate }}"
                        [inOptions]="selectOptions"
                        [fitToSize]="true"
                        >
                    </carm-select-field>
                </div>
                <div *ngIf="!selectOptions" class="col-md-6 col-sm-6">
                    <carm-input-field
                        [group]="filterForm"
                        controlName="criteriaValue"
                        inId="criteria_value"
                        inName="criteriaValue"
                        inLabel="{{ 'concepts.table_filter.keyPhrase' | translate }}"
                        [fitToSize]="true"
                        >
                    </carm-input-field>
                </div>
            </div>
            <div class="row mrgn-bttm-md">
                <div class="col-lg-12 col-md-12 col-sm-12 advance-search-btn-wrapper">
                      <carm-button (click)="searchButtonHandler()"
                                   btnLabel="{{ 'concepts.table_filter.search' | translate }}"
                                   [btnTypePrimary]="true"
                                   [btnStretch]="true"
                                   inId="searchFilterBtn">
                      </carm-button>
                      <carm-button (click)="clearButtonHandler()"
                                   btnLabel="{{ 'concepts.table_filter.clear' | translate }}"
                                   [btnTypeDefault]="true"
                                   [btnStretch]="true"
                                   inId="clearFilterBtn">
                      </carm-button>
                </div>
                <div class="col-lg-6"></div>
            </div>
        </form>
    </mat-expansion-panel>
</div>
